'use strict';

var _ = require('lodash');

/**
 * This repository is a facade around the winINet API using OpenFin messaging to REDI+.
 * The purpose is to share Eikon session cookies around winINet API which is what Eikon uses.
 */
module.exports = /* @ngInject */ ["$q", "$log", "$timeout", "openFinApi", "eikonLoginUrlRepository", "EIKON_SESSION_COOKIE_NAME", "DEVICE_COOKIE_NAME", function ($q, $log, $timeout,
                                           openFinApi,
                                           eikonLoginUrlRepository,
                                           EIKON_SESSION_COOKIE_NAME,
                                           DEVICE_COOKIE_NAME) {
  var that = this;
  var getPromise;

  that.getEikonSsoCookies = function () {
    if (!getPromise) {
      getPromise = get().then(function(winINetCookiesResponse) {
        var cookies = convertToSessionCookies(winINetCookiesResponse);
        if (cookies && cookies.length > 0) {
          $log.info('Retrieved Eikon SSO cookies from winINet');
          return cookies;
        } else {
          return $q.reject();
        }
      });
    }
    return getPromise;
  };

  that.getRtDeviceCookie = function () {
    return get().then(function(winInetCookiesResponse){
      return winInetCookiesResponse.cookies.find(isRtDeviceCookie);
    });
  }

  that.setEikonSsoCookies = function (cookiesAsArrayOfStrings) {
    var winINetSessionCookies = convertToWinINetCookies(cookiesAsArrayOfStrings).filter(isSessionCookie);
    setCookiesForEikonLoginUrl(winINetSessionCookies);
  };

  that.setRtDeviceCookies = function (cookiesAsArrayOfStrings){
    var winINetCookies = convertToWinINetCookies(cookiesAsArrayOfStrings).filter(isRtDeviceCookie);
    setCookiesForEikonLoginUrl(winINetCookies);
  }

  that.setEikonWinINetCookies = function (cookiesAsArrayOfStrings) {
    var winINetCookies = convertToWinINetCookies(cookiesAsArrayOfStrings);
    setCookiesForEikonLoginUrl(winINetCookies);
  }

  function setCookiesForEikonLoginUrl(winINetCookies){
    if(winINetCookies.length > 0){
      eikonLoginUrlRepository.getEikonLoginUrl().then(function (eikonLoginUrl) {
        publishSetWinINetCookies(eikonLoginUrl, winINetCookies);
      });
    }
  }

  that.deleteEikonSsoCookies = function () {
    return eikonLoginUrlRepository.getEikonLoginUrl().then(function (eikonLoginUrl) {
      var domain = getDomainFromUrl(eikonLoginUrl);
      var invalidateCookieArray = [{
        key: EIKON_SESSION_COOKIE_NAME,
        value: 'LOGOUT; Domain=' + domain + '; Expires=Thu, 01-Jan-1970 00:00:10 GMT; Path=/;'
      }];
      return publishSetWinINetCookies(eikonLoginUrl, invalidateCookieArray);
    });
  };

  function getDomainFromUrl(url) {
    var fakeElement = document.createElement('a');
    fakeElement.href = url;
    return fakeElement.host.replace('www', '');
  }

  function get() {
    return eikonLoginUrlRepository.getEikonLoginUrl().then(getForUrl);
  }

  function getForUrl(url) {
    var promise = $q(function(resolve, reject) {
      $log.info('subscribing to wininet cookies');
      openFinApi.subscribe('*', 'wininet-cookies', resolve, null, reject);
      openFinApi.publish('get-wininet-cookies', {url: url}, null, reject);
    });
    return promiseWithTimeout(promise, 10 * 1000);
  }
  function promiseWithTimeout(promise, timeout) {
    return $q(function(resolve, reject) {
      var timeoutPromise = $timeout(reject, timeout);
      promise.then(resolve, reject)
          .finally(function() {
            $timeout.cancel(timeoutPromise);
          });
    });
  }

  function convertToWinINetCookies(cookiesAsArrayOfStrings) {
    return _.chain(cookiesAsArrayOfStrings)
      .map(convertCookieStringtoWinINetObject)
      .value();
  }

  function convertToSessionCookies(winINetCookiesResponse) {
    return _.chain(winINetCookiesResponse.cookies)
    .filter(isSessionCookie)
    .map(createNameValueStringFromCookie)
    .value();
  }

  function convertCookieStringtoWinINetObject(cookieString) {
    var cookieStringFormatted = cookieString.replace(/["$]/g, '');
    var key = cookieStringFormatted.split('=')[0];
    var value = cookieStringFormatted.substring(cookieString.indexOf('=') + 1);
    return {
      key: key,
      value: value
    };
  }

  function isSessionCookie(cookie) {
    return cookie.key === EIKON_SESSION_COOKIE_NAME;
  }

  function isRtDeviceCookie(cookie){
    return cookie.key === DEVICE_COOKIE_NAME;
  }

  function createNameValueStringFromCookie(cookie) {
    return cookie.key + '="' + cookie.value + '";';
  }

  function publishSetWinINetCookies(eikonLoginUrl, winINetCookieArray) {
    return $q(function(resolve, reject) {
      var winINetCookiesToSet = {
        url: eikonLoginUrl,
        cookies: winINetCookieArray
      };
      $log.info('set-wininet-cookies');
      openFinApi.publish('set-wininet-cookies', winINetCookiesToSet, resolve, reject);
    });
  }

}];



//////////////////
// WEBPACK FOOTER
// /app/~/redi-idp-web-lib/dist/business/winINetCookieRepository.js
// module id = 120
// module chunks = 0